




















import { cleanedFileName } from '@/core/utils/utils';
import { getMediaTypeIconClasses } from '@/core/utils/media';

import Vue from 'vue';
export default Vue.extend({
  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mediaTypeIcon() {
      if (!this.attachment) return '';
      return getMediaTypeIconClasses(this.attachment?.file_content);
    },
    hasRemoveListener() {
      return this.$listeners?.remove;
    },
  },
  methods: {
    downloadAttachment(file) {
      return window.open(file.storage_url, '_blank');
    },
    cleanedFileName,
  },
});
